// @flow
import React, { Fragment, useState, } from 'react';
import { FelaComponent, } from 'react-fela';
import { Select, Button, } from '@haaretz/htz-components';

import type { Node, } from 'react';
import type { ExperationDateType, OptionType, } from '../../pages/section/options';

type Props = {
  assets: Array<OptionType>,
  children: string => Node,
  preChange: ?(string, () => void) => Promise<any>,
};

const SelectionLabel = ({ content, }: { content: string, }) => (
  <FelaComponent
    style={({ theme, }) => ({
      fontWeight: '700',
      marginEnd: '1rem',
      extend: [
        theme.mq({ until: 's', }, { display: 'none', }),
      ],
    })}
    as="span"
  >
    {content}
  </FelaComponent>
);

ExpirationBenchmarkFilter.defaultProps = {
  preChange: null,
};

function ExpirationBenchmarkFilter({ assets, children, preChange, }: Props) {
  const [ id, setId, ] = useState(assets[0].id);
  const [ expirationBenchmarkDate, setExpirationBenchmarkDate, ] = useState(assets[0].experationDates[0].id);
  const [ expirationDate, setExpirationDate, ] = useState(assets[0].experationDates[0].id);
  const [ experationDates, setExperationDates, ] = useState(assets[0].experationDates);

  const updateSelection: () => void = () => {
    if (preChange) {
      preChange(expirationBenchmarkDate, () => {
        setExpirationDate(expirationBenchmarkDate);
      });
    }
    else {
      setExpirationDate(expirationBenchmarkDate);
    }
  };

  const selectedItem: ?OptionType = assets.find(asset => asset.id === id);
  const selectedDate: ?ExperationDateType = experationDates.find(expirationDate => (
    expirationDate.id === expirationBenchmarkDate
  ));
  return (
    <Fragment>
      <FelaComponent style={{ position: 'relative', flexGrow: '1', }}>
        <FelaComponent
          style={({ theme, }) => ({
            ...theme.type(-2),
            alignItems: 'baseline',
            display: 'flex',
            justifyContent: 'flex-end',
            paddingTop: '1rem',
            paddingBottom: '1rem',
            position: 'absolute',
            start: '0',
            top: '0',
            width: '100%',
            extend: [
              theme.mq(
                { from: 's', },
                {
                  paddingStart: '2rem',
                  paddingEnd: '2rem',
                }
              ),
              theme.mq(
                { until: 's', },
                { flexWrap: 'wrap', }
              ),
            ],
          })}
        >
          <FelaComponent
            style={({ theme, }) => ({
              display: 'flex',
              alignItems: 'baseline',
              extend: [
                theme.mq(
                  { from: 's', },
                  { marginEnd: '3rem', }
                ),
                theme.mq(
                  { until: 's', },
                  {
                    display: 'block',
                    flexBasis: '100%',
                    marginBottom: '1rem',
                    position: 'relative',
                    zIndex: 6,
                  }
                ),
              ],
            })}
          >
            <SelectionLabel content="בחר נכס בסיס:" />
            <Select
              wrapperStyles={{
                marginEnd: '4rem',
              }}
              dropDownMiscStyles={{
                display: 'block',
                maxHeight: [
                  { until: 's', value: '50rem', },
                  { from: 's', value: '100rem', },
                ],
                overflowY: 'auto',
              }}
              onChange={({ value, }) => {
                const selectedAsset: ?OptionType = assets.find(asset => asset.id === value);
                if (selectedAsset) {
                  setId(selectedAsset.id);
                  setExperationDates(selectedAsset.experationDates);
                  setExpirationBenchmarkDate(selectedAsset.experationDates[0].id);
                }
              }}
              controlledSelectedItem={
                selectedItem
                  ? {
                    value: selectedItem.id,
                    display: selectedItem.value,
                    key: selectedItem.id,
                  }
                  : {}
              }
              variant="graph"
              items={assets.map((asset: OptionType) => ({
                value: asset.id,
                display: asset.value,
                key: asset.id,
              }))}
              buttonMiscStyles={{
                paddingBottom: '0.5rem',
                paddingTop: '0.5rem',
                whiteSpace: 'nowrap',
                minWidth: '15rem',
              }}
            />
          </FelaComponent>
          <FelaComponent
            style={({ theme, }) => ({
              display: 'flex',
              alignItems: 'baseline',
              extend: [
                theme.mq(
                  { from: 's', },
                  { marginEnd: '3rem', }
                ),
                theme.mq(
                  { until: 's', },
                  {
                    display: 'block',
                    flexBasis: '100%',
                    marginBottom: '1rem',
                    position: 'relative',
                    zIndex: 4,
                  }
                ),
              ],
            })}
          >
            <SelectionLabel content="בחר חודש פקיעה:" />
            <Select
              wrapperStyles={{
                marginEnd: '4rem',
              }}
              onChange={({ value, }) => {
                setExpirationBenchmarkDate(value);
              }}
              controlledSelectedItem={selectedDate ? {
                value: selectedDate.id,
                display: selectedDate.value,
                key: `${selectedDate.id}-${selectedDate.value || ''}`,
              } : {}}
              variant="graph"
              items={
                experationDates.map(({ id, value, }) => (
                  {
                    value: id,
                    display: value,
                    key: `${id}-${value}`,
                  }
                ))
              }
              buttonMiscStyles={{
                paddingBottom: '0.5rem',
                paddingTop: '0.5rem',
                whiteSpace: 'nowrap',
                minWidth: '15rem',
              }}
            />
          </FelaComponent>
          <Button
            boxModel={{ hp: 2, vp: 0.5, }}
            fontSize={-1}
            variant="primaryOpaque"
            onClick={updateSelection}
          >
            הצג
          </Button>
        </FelaComponent>
      </FelaComponent>
      {children(expirationDate)}
    </Fragment>
  );
}

export default ExpirationBenchmarkFilter;
